import { Component } from 'react'
import { withRouter } from 'react-router-dom'
import Paper from 'material-ui/Paper'
import StatusCard from './../../../body-card/status-card'
import Divisor from './../../../body-card/card-divisor'
import Alert from './../../../body-card/card-alert'
import Session from 'utils/user-storage'
import InformAdvanceDelayOrder from 'components/inform-advance-delay-order'
import intl from 'react-intl-universal';
import './supplier.css'
import moment from 'moment'
import { formatNumber } from 'utils/format'
import { StatusPedido } from '../../../../../models/pedidos/statusPedido'
import { getGeneralSettingValue } from 'services/general-settings/general-settings'
import { formatDeliveryTime } from 'utils/delivery-time'
import { isLoadCompositionFlowSupplierSide } from 'utils/validations-general-settings'
import { GeneralSettingParameter } from 'models/generalSetting/generalSetting'
import IconCalendarScheduleRefresh from 'components/icons/icn-calendar-refresh.icon'
import IconTruck from 'components/icons/icn-delivery-truck.icon'
import PdfFileIcon from "components/icons/pdf-file.icon";
import { isValidToShowInvoicesPdfFile } from 'utils/invoices-validations'
import PropTypes from 'prop-types'
import ButtonIcon from 'components/button-icon'

const TipoPerfilPcpUnidade = 4;
const TipoNegociacaoPedido = {
  RenegociacaoDePedidoParaAtenderDemanda: 47,
  EmNegociacaoComposicaoCarga: 10
}

export const STATUS_PEDIDO = {
  AGUARDANDO_COMPOSICAO_CARGA: 2,
  EM_NEGOCIACAO_COMPOSICAO_CARGA: 5
};

class ShopSuggestionDetailSupplierCard extends Component {
  constructor() {
    super()

    this.state = {
      openFormOrder: false,
      pedido: {
        NumeroPedido: '',
        NumeroPedidoSap: '',
        NumeroItemPedidoSap: '',
        DesabilitarDataColeta: true,
        DataColeta: '',
        DataEntrega: '',
        PossuiComposicao: false,
        TransitTime: '',
        Quantidade: '',
        Material: '',
        UnidadeMedida: '',
      }
    }
  }

  componentDidMount() {
    this.mountOrder(this.props.dataCard);
  }

  mountOrder = (task) => {
    this.setState({
      pedido: {
        NumeroPedido: task.Negociacao.NumeroPedido,
        NumeroPedidoSap: task.Negociacao.NumeroPedidoSap,
        NumeroItemPedidoSap: task.Negociacao.NumeroItemPedidoSap,
        DesabilitarDataColeta: task.IntStatus === 8,
        DataColeta: moment(task.DataColetaPedido).format('L'),
        DataEntrega: moment(task.DataEntregaPedido).format('L'),
        HoraEntrega: task.HoraEntrega,
        TransitTime: task.TransitTime,
        Quantidade: task.Quantidade,
        Material: task.Material.Nome,
        UnidadeMedida: task.UnidadeMedida,
        IdFornecedor: task.IdFornecedor
      }
    })
  }

  openFormOrder = () => {
    this.setState({
      openFormOrder: true,
    })
  }

  closeFormOrder = () => {
    this.setState({
      openFormOrder: false,
    })
  }

  salvarNovasDatasColetaEntrega = () => {
    this.setState({
      openFormOrder: false,
    })
    this.props.refreshCardDetail()
  }

  goToComposition = () => {
    this.props.history.push(`/composicao/${this.state.pedido.NumeroPedido}`)
  }

  openNewTabPdfPage = (sapOrderCode) => {
    window.open(`/orders/${sapOrderCode}/invoices`);
  };

  habilitarAntecipacaoAtrasoDoPedido = (possuiComposicao, lastNegociation) => (
    lastNegociation !== TipoNegociacaoPedido.RenegociacaoDePedidoParaAtenderDemanda
    && lastNegociation !== TipoNegociacaoPedido.EmNegociacaoComposicaoCarga
    && possuiComposicao
    && isLoadCompositionFlowSupplierSide());

  isDisableLoadCompositionButton = (intStatus) => {
    return getGeneralSettingValue(GeneralSettingParameter.LoadCompositionNewFlow) ? intStatus === StatusPedido.AguardandoComposicaoCarga
      : this.perfilPcpUnidadeLogado() || intStatus < 5 && intStatus !== StatusPedido.AguardandoComposicaoCarga || intStatus === StatusPedido.AguardandoAprovacaoGestor || intStatus === StatusPedido.AguardandoCiencia
  }

  perfilPcpUnidadeLogado = () => Session.get().PerfilAcesso === TipoPerfilPcpUnidade

  render() {
    const task = this.props.dataCard
    const heightCard = task.Sugestao ? 'calc(100% - 5px)' : '265px'

    return (
      <Paper
        zDepth={1}
        className='card-shop-detail-supplier'
        style={{ height: heightCard }}>

        {task.Tipo.Alerta && <Alert />}

        <div className='card-click-area'>

          <div className='header-card-shop-detail-supplier'>
            <StatusCard
              tipo={task.Tipo}
              material={task.Material.Nome}
            />
          </div>

          <Divisor />

          <div className='body-card'>
            <div className='card-label'>
              <span>{intl.get('stocks.timeline.factory')}</span>
              <span>{task.Fabrica.Nome}</span>
            </div>
            <div className='card-label'>
              <span>{intl.get('stocks.timeline.status')}</span>
              <span>{task.Status}</span>
            </div>
          </div>

          <Divisor />

          <div className='body-card'>
            <div className='card-label'>
              <span>{intl.get('stocks.timeline.origin')}</span>
              <span>{task.Fornecedor}</span>
            </div>
          </div>

          <Divisor />

          {task.Negociacao && <div className='detail-body'>
            <div className='card-row-shop-detail-supplier'>
              <div className='card-label-shop-detail-supplier'>
                <span> {!!task.PedidoVolume ? intl.get('stocks.volumeCode') : intl.get('stocks.portalCode')}</span>
                <span><strong>{task.Negociacao.NumeroPedido}</strong></span>
              </div>
            </div>

            <div className='card-row-shop-detail-supplier'>
              <div className='card-label-shop-detail-supplier'>
                <span>{intl.get('stocks.qty')}:</span>
                <span><strong>{`${formatNumber(task.Negociacao.QuantidadeProposta)} ${task.Negociacao.UnidadeMedidaProposta}`}</strong></span>
              </div>
            </div>

            <div className='card-row-shop-detail-supplier'>
              <div className='card-label-shop-detail-supplier'>
                <span>{intl.get('stocks.collectionDate')}</span>
                <span><strong>{moment(task.Negociacao.DataColetaPropostaFormatada, "DD/MM/YYYY").format("L")}</strong></span>
              </div>
            </div>

            <div className='card-row-shop-detail-supplier'>
              <div className='card-label-shop-detail-supplier'>
                <span>{intl.get('stocks.deliveryDate')}</span>
                <span>
                  <strong>
                    {`${moment(task.Negociacao.DataEntregaPropostaFormatada, "DD/MM/YYYY").format("L")} ${formatDeliveryTime(task.HoraEntrega)}`}
                  </strong>
                </span>
              </div>
            </div>
          </div>
          }

          {!task.PedidoVolume && <div>
            <Divisor />
            <div className='timeline-actions'>
              {isValidToShowInvoicesPdfFile(task.CodigoPedidoSap, task.IntTipoPedido) &&
                <div title={intl.get("commons.openPdfFile")} className="card-detail-button-container">
                  <ButtonIcon
                    className="pdf-file-button"
                    style={{width:"50px"}}
                    buttonType="default"
                    buttonIcon={<PdfFileIcon />}
                    onClick={() => this.openNewTabPdfPage(task.CodigoPedidoSap)}
                  />
                </div>
              }
              <div title={intl.get("stocks.suggestionsListItem.goLoadComposition")} className="card-detail-button-container">
                <ButtonIcon
                  disabled={this.isDisableLoadCompositionButton(task.IntStatus)}
                  buttonType="default"
                  buttonIcon={<IconTruck />}
                  onClick={this.goToComposition}
                  data-testid='button-go-load-composition'
                />
              </div>
              <div title={intl.get("stocks.suggestionsListItem.InformChangeOrder")} className="card-detail-button-container">
                <ButtonIcon
                  disabled={!this.habilitarAntecipacaoAtrasoDoPedido(task.PossuiComposicao,
                    task.CodigoStatus
                  )}
                  buttonType='default'
                  buttonIcon={<IconCalendarScheduleRefresh />}
                  onClick={this.openFormOrder}
                  data-testid="button-go-calendar"
                />
              </div>
            </div>
          </div>
          }

          {this.state.openFormOrder &&
            <InformAdvanceDelayOrder
              open
              pedido={this.state.pedido}
              onClose={this.closeFormOrder}
              onSave={this.salvarNovasDatasColetaEntrega}
            />
          }
        </div>
      </Paper>
    )
  }
}

ShopSuggestionDetailSupplierCard.propTypes = {
  dataCard: PropTypes.shape({
    Sugestao: PropTypes.any,
    Tipo: PropTypes.shape({
      Alerta: PropTypes.bool
    }),
    Material: PropTypes.shape({
      Nome: PropTypes.string
    }),
    Fabrica: PropTypes.shape({
      Nome: PropTypes.string
    }),
    Status: PropTypes.number,
    Fornecedor: PropTypes.object,
    Negociacao: PropTypes.shape({
      NumeroPedido: PropTypes.number,
      QuantidadeProposta: PropTypes.number,
      UnidadeMedidaProposta: PropTypes.string,
      DataColetaPropostaFormatada: PropTypes.string,
      DataEntregaPropostaFormatada: PropTypes.string
    }),
    PedidoVolume: PropTypes.object,
    HoraEntrega: PropTypes.string,
    CodigoPedidoSap: PropTypes.string,
    IntTipoPedido: PropTypes.number,
    IntStatus: PropTypes.number,
    PossuiComposicao: PropTypes.bool,
    CodigoStatus: PropTypes.number,
    

  }),

  refreshCardDetail: PropTypes.func,
  history: PropTypes.shape({
    push: PropTypes.func
  })
}

export default withRouter(ShopSuggestionDetailSupplierCard)
